import Dialog from '@rio-cloud/rio-uikit/components/dialog/Dialog';
import { useAppDispatch } from '../../../../state/hooks';
import Button from '@rio-cloud/rio-uikit/components/button/Button';
import {
  openAddNewServiceCardDialog,
  selectVehicle,
} from '../../../onboarding/state/onboardingUiSlice';
import { ONBOARDING_ROUTE } from '../../../../routes/routes';
import { useNavigate } from 'react-router-dom';
import { PaymentPartnerType } from '../../../../codegen/vehicles';
import { appConfiguration } from '../../../../configuration/appConfiguration';
import Select from '@rio-cloud/rio-uikit/components/selects/Select';
import { useState } from 'react';
import { useVehicles } from '../../../../state/vehicles/useVehicles';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

type AddCardDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const AddCardDialog = ({ open, onClose }: AddCardDialogProps) => {
  const { vehicles } = useVehicles();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const defaultPaymentPartnerType = appConfiguration
    .supportedPaymentPartnerTypes[0] as PaymentPartnerType;

  const [selectedVehicleId, setSelectedVehicleId] = useState<
    string | undefined
  >();

  return (
    <Dialog
      data-testid={'vehicle-selection-dialog'}
      bsSize={Dialog.SIZE_SM}
      show={open}
      onClose={onClose}
      title={
        <FormattedMessage id="overview.quickActions.addCardDialog.title" />
      }
      body={
        <div>
          <div>
            <FormattedMessage id="overview.quickActions.addCardDialog.headerText" />
          </div>
          <Select
            placeholder="Please select"
            value={selectedVehicleId ? [selectedVehicleId] : []}
            options={vehicles.map((vehicle) => ({
              id: vehicle.id,
              label: vehicle.name,
              icon: <span className="rioglyph rioglyph-truck" />,
            }))}
            onChange={(item) => setSelectedVehicleId(item?.id)}
            className={classNames(
              'margin-top-10',
              selectedVehicleId && 'has-value',
            )}
            useClear
            useFilter
          />
        </div>
      }
      footer={
        <Button
          bsStyle="primary"
          type="submit"
          onClick={() => {
            if (selectedVehicleId) {
              dispatch(selectVehicle(selectedVehicleId));
              dispatch(
                openAddNewServiceCardDialog({
                  paymentPartnerType: defaultPaymentPartnerType,
                }),
              );
              navigate(ONBOARDING_ROUTE);
            }
          }}
          disabled={!selectedVehicleId}
        >
          <FormattedMessage id={'common.action.confirm'} />
        </Button>
      }
    />
  );
};
